import axios from "axios";
import { cacheAdapterEnhancer } from "axios-extensions";
import * as SwalUtils from "../utils/SwalUtils.js";

const baseURL = document.baseURI;

const cacheConfig = {
  enabledByDefault: true,
};

const { adapter } = axios.defaults;
if (adapter === undefined) throw new Error(`No Axios adapter defined.`);

const httpClient = axios.create({
  baseURL: baseURL,
  timeout: 30000,
  headers: {
    "Cache-Control": "no-cache",
  },
  adapter: cacheAdapterEnhancer(adapter, cacheConfig),
});

const errorInterceptor = (error) => {
  switch (error.response.status) {
    case 400:
      if (error.response.data.errors) {
        error.response.data.errors.forEach((error) => {
          SwalUtils.DisplayErrorToast(error.message);
        });
      } else {
        SwalUtils.DisplayErrorToast("Er is iets foutgelopen.");
      }

      break;
    default:
      SwalUtils.DisplayErrorToast("Er is iets foutgelopen.");
  }
  return Promise.reject(error);
};

const responseInterceptor = (response) => {
  switch (response.status) {
    case 200:
      // eventuele succes alert bij sommige dingen
      break;
    default:
  }
  return response;
};

httpClient.interceptors.response.use(responseInterceptor, errorInterceptor);

export default httpClient;
